import { Component, EventEmitter, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ExposedListPublicRegistryPersonsRes } from 'app/interfaces/responses/Exposed/exposedListPublicRegistryPersonsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogUserAddData {}

@Component({
    selector: 'dialog-settings-users-add',
    templateUrl: 'dialog-settings-users-add.html',
    styleUrls: ['dialog-settings-users-add.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogSettingsUsersAdd extends DialogGeneral {
    @ViewChild('ngForm') ngForm: NgForm;
    form: UntypedFormGroup;
    formEnabled = true;
    findNameLoaderEnabled = false;
    onConfirm = new EventEmitter();

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<DialogSettingsUsersAdd>,
        private _formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        private lsrauthService: LsrauthService,
        @Inject(MAT_DIALOG_DATA) public data: DialogUserAddData
    ) {
        super(dialogRef);
        this.initForm();
    }

    initForm() {
        this.form = this._formBuilder.group({
            ssn: new UntypedFormControl('', [Validators.required]),
        });
    }

    optionSelected = (option: ExposedListPublicRegistryPersonsRes) => {
        this.form.get('ssn').setValue(option.ssn);
    };

    addUser() {
        this.form.markAllAsTouched();
        this.formEnabled = false;
        this.form.disable();

        this.lsrauthService
            .createUser({
                socialSecurityNumber: this.form.get('ssn').value,
                isExternalEmployee: true,
            })
            .subscribe((userId) => {
                if (userId) {
                    this.onConfirm.emit(true);
                    this.dialogRef.close();
                } else {
                    this.formEnabled = true;
                    this.form.enable();
                }
            });
    }
}
